module.exports = __webpack_public_path__ + "img/huanjing.ec3b78b3.jpg";